<template>
    <div>
        <!-- Input -->
        <b-form-file
            :ref="id"
            :placeholder="placeholder"
            :browse-text="browseText"
            :disabled="!! uploadProgress || disabled"
            :multiple="multiple"
            @input="onFileInput"
            no-drop
        ></b-form-file>

        <div class="pt-2" v-if="uploadProgress">
            <b-progress :max="100">
                <b-progress-bar :value="uploadProgress" :label="`${((uploadProgress / 100) * 100).toFixed(2)}%`" animated></b-progress-bar>
            </b-progress>
        </div>
    </div>
</template>

<script>
export default {
    emits: [
        'uploading',
        'success',
        'error'
    ],
    props: {
        id: {
            type: String,
            required: true
        },
        accept: {
            type: String,
            default: 'image/*'
        },
        placeholder: {
            type: String,
            default: 'Choose a file or drop it here...'
        },
        browseText: {
            type: String,
            default: 'Browse'
        },
        multiple: {
            type: Boolean,
            default: false
        },
        path: {
            type: String,
            default: ''
        },
        successMessage: {
            type: String,
            default: 'O arquivo foi carregado com sucesso!'
        },
        canClear: {
            type: Boolean,
            default: true
        },
        disabled: {
            type: Boolean,
            default: false
        },
        maxFileSize: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            uploadProgress: null,
        }
    },
    methods: {
        async onFileInput() {
            for (let index = 0; index < this.$refs[this.id].files.length; index++) {
                await this.uploadFile(this.$refs[this.id].files[index], index);
            }
        },

        async uploadFile(inputFile, index) {

            let mimeTypesToValidate = [];
            // block files more than 5mb exact bytes
            if (inputFile.size > this.maxFileSize && this.maxFileSize != 0) {
                this.$toast.error('O arquivo ' + inputFile.name + ' ultrapassa o limite de 5mb, selecione outro arquivo');
                
                return;
            }
            // get mime types to validate, ex: image/*, application/pdf
            if (this.accept) {
                mimeTypesToValidate = this.accept.split(',');
            }

            // validate mime type
            if (mimeTypesToValidate.length > 0) {
                let isValid = false;
                
                for (let index = 0; index < mimeTypesToValidate.length; index++) {
                    const mimeType = mimeTypesToValidate[index];

                    if (mimeType.includes('*')) {
                        const mimeTypeToValidate = mimeType.replace('*', '');

                        if (inputFile.type.includes(mimeTypeToValidate)) {
                            isValid = true;
                            break;
                        }
                    } else {
                        if (inputFile.type === mimeType) {
                            isValid = true;
                            break;
                        }
                    }
                }

                if (! isValid) {
                    this.$toast.error('O tipo de arquivo não é permitido. Por favor, selecione outro arquivo.');
                    return;
                }
            }

            this.$emit('uploading', true);

            await Vapor.store(inputFile, {
                progress: progress => {
                    this.uploadProgress = Math.round(progress * 100);
                }
            })
                .then(async response => {
                    await axios.post('/save-file-in-disk', {
                        success: true,
                        uuid: response.uuid,
                        key: response.key,
                        bucket: response.bucket,
                        extension: response.extension,
                        path: this.path,
                        name: inputFile.name,
                        size: inputFile.size,
                        type: inputFile.type,
                    })
                        .then(response => {
                            this.$emit('success', response.data);

                            this.$toast.success(this.successMessage);

                            if (this.canClear) {
                                this.$refs[index].value = '';
                            }
                        })
                        .catch(error => {
                            this.$emit('error', error);
                        })
                })
                .catch((error) => {
                    this.uploadProgress = null;
                    this.$emit('error', error);
                })
                .finally(() => {
                    this.uploadProgress = null;
                    this.$emit('uploading', false);
                    this.loading = false;
                })
        }
    }
}
</script>

<style scoped>

</style>
